<h2 mat-dialog-title>{{ titleLabel }}</h2>
<mat-dialog-content>
  <div class="suggest-content">
    <form [formGroup]="suggestForm" class="suggest-form">
      <!-- Dictionary dropdown (only when more than one qualifying dictionary) -->
      @if (showDictionarySelect) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ dictionaryLabel }}</mat-label>
          <mat-select formControlName="dictionaryId">
            @for (dict of data.dictionaries; track dict.id) {
              <mat-option [value]="dict.id">{{ dict.name }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      }
      <!-- Term name field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ termNameLabel }}</mat-label>
        <input matInput formControlName="termName">
        @if (suggestForm.get('termName')?.hasError('required')) {
          <mat-error>
            {{ requiredError }}
          </mat-error>
        }
      </mat-form-field>
      <!-- Language dropdown -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ languageLabel }}</mat-label>
        <mat-select formControlName="languageCode">
          @for (lang of languages; track lang.code) {
            <mat-option [value]="lang.code">{{ lang.name }}</mat-option>
          }
        </mat-select>
        @if (suggestForm.get('languageCode')?.hasError('required')) {
          <mat-error>
            {{ requiredError }}
          </mat-error>
        }
      </mat-form-field>
    </form>
    <!-- Duplicate warning -->
    @if (duplicateWarning) {
      <div class="duplicate-warning">
        <mat-icon>warning</mat-icon>
        <span>{{ duplicateWarning }}</span>
      </div>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary"
    (click)="submit()"
    [disabled]="submitting || suggestForm.invalid">
    @if (submitting) {
      <mat-spinner diameter="20" class="button-spinner"></mat-spinner>
    }
    @if (!submitting) {
      <span>{{ submitLabel }}</span>
    }
  </button>
  <button mat-button (click)="cancel()">{{ cancelLabel }}</button>
</mat-dialog-actions>
